module.exports = {
    serverErrorPrecontractual: {
        errorTitle: 'contractsView-juniorAccountHire_contractualErrorTitle',
        errorBody: 'contractsView-checkingAccountHire_contractualErrorBody',
        backButtonLabel: 'contractsView-contractsView_legalWindowErrorBackButtonLabel',
        backButtonLink: '/myprofile/accounts'
    }
}
